module.exports = __webpack_public_path__ + "img/change-language.62f8aa80.svg";